import {getStoredProcedure} from '@/data/repos/storedProcedure'
import {reformatDate} from "@/data/sources/dates"

export async function getJobsAllocatedInAMonth(
  userId: number,
  month: number,
  year: number,
  ppmRepairAll: number,
  category: number,
  contractor: number,
  usecategory: number): Promise<Array<{ value: string, label: string }>> {
  return getStoredProcedure(
    'AnalyticsCenter',
    'widget_JobsAllocatedInAMonth',
    [userId, month, year, ppmRepairAll, category, contractor, usecategory])
}

export async function getJobsAllocatedInAMonthGrid(
  userId: number,
  month: number,
  year: number,
  ppmRepairAll: number,
  category: number,
  contractor: number,
  usecategory: number,
  status: number,
  offset: number = 0,
  limit: number = 250): Promise<object[]> {
  return getStoredProcedure(
    'AnalyticsCenter',
    'widget_JobsAllocatedInAMonth_Grid',
    [userId, month, year, ppmRepairAll, category, contractor, usecategory, status],
    filterBreakdown, offset, limit)
}

function filterBreakdown(data: any[]): any {
  const filteredData: any[] = []
  for (const item of data) {
    filteredData.push({
      ...item,
      Reported_Date_Time: reformatDate(item.Reported_Date_Time),
      Complete_Date: reformatDate(item.Complete_Date),
    })
  }
  return filteredData
}
